/* eslint-disable import/extensions */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component007.less';
interface IComponents007Props {
  title: string;
  img: string;
}

const Components004: React.FunctionComponent<IComponents007Props> = ({
  title,
  img,
}) => (
  <>
    <div className="component007">
      <div className="pic">
        <img src={require(`../../../../../assets/${img}`).default} alt="" />
      </div>
      <div
        className="component007-1"
        dangerouslySetInnerHTML={{ __html: title }}
      />
    </div>
  </>
);

export default Components004;
